// featureloader.js

// Import the product features configuration
// This file specifies which features are enabled and the corresponding modules to load.
import productFeatures from '../../productfeatures.config.js';

// Map static imports to feature names
// const staticModules = {
//   helloWorld: HelloWorldServer,
//   anotherFeature: AnotherFeatureServer,
// };

// Specify we'll be loading all .js files under server
// const serverModulesContext = require.context(
//   '../../server', // Base directory
//   true,           // Include subdirectories
//   /\.js$/         // Match all `.js` files
// );



/**
 * Dynamically loads and initializes enabled features based on configuration.
 * 
 * - For enabled features: Loads client or server modules and assigns their default export or fallback.
 * - For disabled features: Assigns the `fallback` (typically a noop function).
 * 
 * @param {boolean} isServer - Indicates whether to load server or client modules.
 * @returns {object} An object mapping feature names to their loaded functionality (or fallback).
 */

export default async function loadFeatures(isServer) {
  const loadedFeatures = {};
  const context = isServer
    ? require.context('../../server/features', true, /\.js$/)
    : require.context('../../js/features', true, /\.js$/);

  console.log('Modules available in context:', context.keys());

  for (const [featureName, featureConfig] of Object.entries(productFeatures.features)) {
    if (featureConfig.enabled) {
      console.log(`Loading feature: ${featureName}`);

      const modules = isServer ? featureConfig.serverModules : featureConfig.clientModules;

      // Use Promise.all to handle asynchronous module loading
      const featureModules = await Promise.all(
        modules.map(async (modulePath) => {
          console.log(`About to try to load "${modulePath}" for feature "${featureName}"`);
          try {
            const module = await context(modulePath); // Await resolution of the module
            console.log(`Module loaded for "${featureName}":`, module);
            return module.default || module; // Return default export if available
          } catch (error) {
            console.error(`Failed to load module "${modulePath}" for feature "${featureName}":`, error);
            return null;
          }
        })
      );

      // Merge all loaded modules for the feature
      loadedFeatures[featureName] = featureModules.reduce((acc, module) => ({ ...acc, ...module }), {});
    } else {
      loadedFeatures[featureName] = null;
    }
  }

  return loadedFeatures;
}


// export default function loadFeatures(isServer) {
//   const loadedFeatures = {};
//   console.log('In loadFeatures.  Server features modules available:', require.context('../../server/features', true, /\.js$/).keys());
//   var context = null;

//   // const context = require.context(
//   //   '../../server/features', // The folder where feature modules reside
//   //   true, // Recursive
//   //   /\.js$/ // Match JavaScript files
//   // );

//   if (isServer) {
//     // Context for server-side features
//     context = require.context(
//       '../../server/features', // Server-side feature folder
//       true, // Recursive
//       /\.js$/ // Match JavaScript files
//     );
//     console.log('In loadFeatures. Server features modules available:', context.keys());
//   } else {
//     // Context for client-side features
//     context = require.context(
//       '../../js/features', // Client-side feature folder
//       true, // Recursive
//       /\.js$/ // Match JavaScript files
//     );
//     console.log('In loadFeatures. Client features modules available:', context.keys());
//   }


//   console.log('Available modules in context:', context.keys());


//   for (const [featureName, featureConfig] of Object.entries(productFeatures.features)) {
//     if (featureConfig.enabled) {
//       console.log(`Loading feature: ${featureName}`);
//       console.log(`This is a ${isServer ? 'server' : 'client'} feature`);

//       // Note that modules can be null if there are no .js files associated with the feature (yet)
//       // This is for development when a feature may - for now - just be a flag
//       if (featureConfig.clientModules || featureConfig.serverModules) {
//         const modules = isServer ? featureConfig.serverModules : featureConfig.clientModules;
//         loadedFeatures[featureName] = modules.reduce((acc, modulePath) => {
//           console.log(`About to try to load "${modulePath}" for feature "${featureName}"`);
//           try {
//             // const module = require(modulePath);  // why not no context since it worked above?
//             const module = context(modulePath);  // why not no context since it worked above?

//             console.log(`Loaded module for "${featureName}":`, module);

//             return { ...acc, ...module };
//           } catch (error) {
//             console.error(`Failed to load module "${modulePath}" for feature "${featureName}":`, error);
//             return acc;
//           }
//         }, {});
//       }
//     else { // what to do when there are no modules TODO 
//       // Maybe nothing special to do here? Will we still see that featureName is enabled somehow?
//       }
    
//     } else {
//       loadedFeatures[featureName] = null; // When feature is enabled just set the value to null
//     }
//   }
//   return loadedFeatures;
// }
      
//     try {
//       if (featureConfig.enabled) {
//         console.log(`Loading feature: ${featureName}`);
        
//         //const modules = isServer ? featureConfig.modules.server : featureConfig.modules.client;
//         const modules = isServer ? featureConfig.serverModules : featureConfig.clientModules;

//         // if (!modules) {
//         //   console.error(`Feature "${featureName}" does not have ${isServer ? 'server' : 'client'} modules defined.`);
//         //   continue; // Skip loading this feature
//         // }

// // Handle server-side (static) and client-side (dynamic) modules
//   //       if (isServer) {
//   //         loadedFeatures[featureName] = modules || featureConfig.fallback;
//   //       } else {
//   //         loadedFeatures[featureName] = modules.map((modulePath) => {
//   //           try {
//   //             const module = require(modulePath); // Dynamic require for client
//   //             return module.default || featureConfig.fallback;
//   //           } catch (error) {
//   //             console.error(
//   //               `Failed to load module "${modulePath}" for feature "${featureName}":`,
//   //               error
//   //             );
//   //             return featureConfig.fallback; // Assign fallback on module load failure
//   //           }
//   //         });
//   //       }
//   //     } else {
//   //       // Feature is disabled, assign fallback
//   //       loadedFeatures[featureName] = featureConfig.fallback;
//   //     }
//   //   } catch (error) {
//   //     console.error(`Error processing feature "${featureName}":`, error);
//   //     loadedFeatures[featureName] = featureConfig.fallback;
//   //  }

